import { render, staticRenderFns } from "./TestTaskResults.vue?vue&type=template&id=c6a4604e&scoped=true&"
import script from "./TestTaskResults.vue?vue&type=script&lang=js&"
export * from "./TestTaskResults.vue?vue&type=script&lang=js&"
import style0 from "./TestTaskResults.vue?vue&type=style&index=0&id=c6a4604e&lang=scss&scoped=true&"
import style1 from "./TestTaskResults.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a4604e",
  null
  
)

export default component.exports